

import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
// TEMP: blank page for a ShortedLogo screenshot, remove this import and its route below when told
import ShortedLogo from './components/ShortedLogo';





// Route-level code splitting: HomePage ("/") is the most common landing page and stays eagerly
// imported so it renders with no extra Suspense flicker. Every other route (including the entire
// admin panel subtree, which is the largest and least-visited) is lazy-loaded, so a first-time
// visitor to "/" no longer downloads/parses that code at all.
const GameRoom = lazy(() => import('./components/gameroom/GameRoom'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminPanel = lazy(() => import('./components/admin/AdminPanel'));
const KeyGenerator = lazy(() => import('./components/KeyGenerator'));
const Withdraw = lazy(() => import('./pages/Withdraw'));
const ReferralSection = lazy(() => import('./components/ReferralSection'));
const ReferralDashboard = lazy(() => import('./components/ReferralDashboard'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const ForgotPassword = lazy(() => import('./components/ForgotPassword'));
const ResetPassword = lazy(() => import('./components/ResetPassword'));
const EmailVerification = lazy(() => import('./components/EmailVerification'));
// Prediction Hub / Simulation Arena - separate feature, separate auth (predictionAuth.js), kept as
// its own lazy chunk group.
const PredictionAuth = lazy(() => import('./components/prediction/PredictionAuth'));
const PredictionHub = lazy(() => import('./components/prediction/PredictionHub'));
const SimulationArena = lazy(() => import('./components/prediction/SimulationArena'));
const NotFound = lazy(() => import('./pages/NotFound'));

function RouteLoadingFallback() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{
        width: '28px', height: '28px',
        border: '3px solid #e9ecef', borderTopColor: '#40c057',
        borderRadius: '50%', animation: 'spin 0.8s linear infinite',
      }} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" reverseOrder={false} />
      <Suspense fallback={<RouteLoadingFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/game" element={<GameRoom />} />

          {/* ✅ Hidden admin routes */}
          {/*
          // SECURITY NOTE: This implementation appears secure against the security-by-obscurity finding
          // formerly noted here - AdminPanel.jsx now independently re-verifies a real server-side admin
          // session (GET /api/admin/me, httpOnly cookie) on mount and renders nothing (`return null`)
          // until that check passes, regardless of how the route was reached. Every admin API call also
          // requires the adminAuth-validated cookie server-side, so discovering the URL alone grants no
          // access.
          // ⚡ SEVERITY: ⚪ INFO - 0%
          */}
          <Route path="/molxi" element={<AdminLogin />} />
          <Route path="/molxi/panel" element={<AdminPanel />} />
          {/* Simulation Arena is admin-only (see SimulationArena.jsx's own GET /api/admin/me
              check) - kept under the same "hidden admin route" convention as /molxi/panel. */}
          <Route path="/molxi/simulation" element={<SimulationArena />} />

          {/*
          // SECURITY NOTE: This implementation appears secure against the missing-rate-limiting-assumption
          // finding formerly noted here - confirmed (not assumed) that backend/routes/keyGeneratorRoutes.js
          // applies `router.use(keyGenLimiter)` router-wide, covering both /can-generate and /generate.
          // ⚡ SEVERITY: ⚪ INFO - 0%
          */}
          <Route path="/key-generator" element={<KeyGenerator />} />
          <Route path="/withdraw" element={<Withdraw />} />

          <Route path="/referral" element={<ReferralSection />} />
          <Route path="/referral-dashboard" element={<ReferralDashboard />} />

          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<EmailVerification />} />

          {/* Prediction Hub - separate feature, separate auth from the game/referral/admin flows
              above (see backend/middleware/predictionAuth.js). Simulation Arena (admin-only) is
              registered under /molxi above instead, alongside the rest of the admin routes. */}
          <Route path="/predict" element={<PredictionAuth />} />
          <Route path="/predict/hub" element={<PredictionHub />} />

          {/* TEMP: blank page for a ShortedLogo screenshot, remove this route when told */}
          <Route path="/logo-preview" element={
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
              <ShortedLogo />
            </div>
          } />

          <Route path="*" element={<NotFound />} />

        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
